import { Model } from "@westpierstudio/luma/mvc";

export type PositionList = {x: number, y: number}[];

export interface WheelPrizePanelLayout {
    globalSymbolDisplayPositions: {
        twoSymbols: PositionList,
        sixSymbols: PositionList
    }
}

export class WheelPrizePanelModel extends Model {
    layout!: WheelPrizePanelLayout;

    setupLayout(): void {

        const spec = this.services.resources.getSpec(`wheelprizepanel`);

        const twoSymbols = this.createPositionList(spec.x, spec.y, spec.symbolPanel.symbolPositions.two.final);
        const sixSymbols = this.createPositionList(spec.x, spec.y, spec.symbolPanel.symbolPositions.six.final);

        this.layout = {
            globalSymbolDisplayPositions: {
                twoSymbols,
                sixSymbols
            }
        };
    }

    private createPositionList(baseX: number, baseY: number, displayList: PositionList): PositionList {
        return displayList.map((item) => {
            return {x: baseX + item.x, y: baseY + item.y};
        });
    }
}